/**
 * Preferences propres au solitaire, persistees en localStorage : mode de
 * tirage (1 ou 3 cartes, cahier des charges §2 — 3 par defaut), affichage du
 * chrono (masquable, §8 : certains jouent justement pour ne pas etre
 * chronometres) et surbrillance des coups possibles (§6, option activable).
 */

export interface SolitaireSettings {
  /** true = tirage par 3 (mode standard), false = tirage par 1. */
  draw3: boolean;
  /** Affiche le chrono dans le HUD. */
  showTimer: boolean;
  /** Halo sur les cibles valides pendant un glisser-deposer. */
  highlight: boolean;
}

const STORAGE_KEY = "dkg-solitaire:settings:v1";

const DEFAULTS: SolitaireSettings = { draw3: true, showTimer: true, highlight: true };

export function loadSettings(): SolitaireSettings {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<SolitaireSettings>) };
  } catch {
    // Stockage indisponible ou corrompu : valeurs par defaut, pas bloquant.
  }
  return { ...DEFAULTS };
}

export function saveSettings(settings: SolitaireSettings): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // Stockage indisponible : pas bloquant.
  }
}
